// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ListUtils from "../utils/ListUtils.bs.js";
import * as Json_decode from "../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function id(t) {
  return t.id;
}

function userId(t) {
  return t.userId;
}

function name(t) {
  return t.name;
}

function avatarUrl(t) {
  return t.avatarUrl;
}

function fullTitle(t) {
  return t.fullTitle;
}

function decode(json) {
  return {
          id: Json_decode.field("id", Json_decode.string, json),
          userId: Json_decode.field("userId", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json),
          avatarUrl: Json_decode.optional((function (param) {
                  return Json_decode.field("avatarUrl", Json_decode.string, param);
                }), json),
          fullTitle: Json_decode.field("fullTitle", Json_decode.string, json)
        };
}

function findById(id, proxies) {
  return ListUtils.unsafeFind((function (proxy) {
                return proxy.id === id;
              }), "Unable to find a UserProxy with ID " + id, proxies);
}

function make(id, userId, name, avatarUrl, fullTitle) {
  return {
          id: id,
          userId: userId,
          name: name,
          avatarUrl: avatarUrl,
          fullTitle: fullTitle
        };
}

function makeFromJs(jsObject) {
  return make(jsObject.id, jsObject.userId, jsObject.name, jsObject.avatarUrl, jsObject.fullTitle);
}

var Raw = {};

function parse(value) {
  var value$1 = value.avatarUrl;
  return {
          id: value.id,
          name: value.name,
          userId: value.userId,
          fullTitle: value.fullTitle,
          avatarUrl: !(value$1 == null) ? value$1 : undefined
        };
}

function serialize(value) {
  var value$1 = value.avatarUrl;
  var avatarUrl = value$1 !== undefined ? value$1 : null;
  var value$2 = value.fullTitle;
  var value$3 = value.userId;
  var value$4 = value.name;
  var value$5 = value.id;
  return {
          id: value$5,
          name: value$4,
          userId: value$3,
          fullTitle: value$2,
          avatarUrl: avatarUrl
        };
}

function verifyArgsAndParse(_UserProxyFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var Fragment = {
  Raw: Raw,
  query: "fragment UserProxyFragment on UserProxy   {\nid  \nname  \nuserId  \nfullTitle  \navatarUrl  \n}\n",
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

function makeFromFragment(user) {
  return make(user.id, user.userId, user.name, user.avatarUrl, user.fullTitle);
}

export {
  id ,
  userId ,
  name ,
  avatarUrl ,
  fullTitle ,
  decode ,
  findById ,
  make ,
  makeFromJs ,
  Fragment ,
  makeFromFragment ,
}
/* No side effect */
